import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getSchoolConfig } from './utils/domainConfig';
import Login from './components/Login';
import HomePage from './components/HomePage';
import Students from './components/students/Students';
import Staffs from './components/staffs/Staffs';
import Attendance from './components/attendance/Attendance';
import Dashboard from './components/dashboard/Dashboard';
import Classes from './components/classes/Classes';
import Exams from './components/exams/Exams';
import Results from './components/results/Results';
import Settings from './components/settings/Settings';
import BulkNotice from './components/announcement/BulkNotice';
import Chats from './components/announcement/Chats';
import TemplateInsights from './components/announcement/TemplateInsights';
import Gallery from './components/announcement/Gallery';
import Fees from './components/academic/Fees';
import Transactions from './components/academic/Transactions';
import Receipt from './components/academic/Receipt';
import TrackVehicles from './components/vehicles/TrackVehicles';
import StudentPromotion from './components/utility/StudentPromotion';
import SystemProperties from './components/utility/SystemProperties';
import Reconciliation from './components/utility/Reconciliation';
import NotificationTester from './components/announcement/NotificationTester';
import PrivacyPolicy from './components/public/PrivacyPolicy';
import Header from './components/Header';
import './styles/App.css';
import StudentPayments from './components/student/StudentPayments';
import ProtectedRoute from './components/ProtectedRoutes';

function App() {
  useEffect(() => {
    const schoolConfig = getSchoolConfig();
    document.title = `${schoolConfig.schoolName} - ${schoolConfig.subtitle}`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', `${schoolConfig.schoolName} - ${schoolConfig.subtitle}`);
    }

    const preventScrollOnNumber = (e) => {
      if (e.target.type === 'number') e.target.blur();
    };
    document.addEventListener('wheel', preventScrollOnNumber, { passive: false });
    return () => document.removeEventListener('wheel', preventScrollOnNumber);
  }, []);

  return (
    <Router>
      <div className="app-container">
        <Routes>
          {/* Public routes without header - MUST come before wildcard */}
          <Route path="/login" element={<div className="full-page"><Login /></div>} />
          <Route path="/privacy-policy" element={<div className="full-page"><PrivacyPolicy /></div>} />
          <Route path="/academic/transaction/:id" element={<Receipt />} />
          
          {/* Protected routes with header */}
          <Route path="/home" element={<><Header /><div className="page-content"><HomePage /></div></>} />
          <Route path="/student/payments" element={<><Header /><div className="page-content"><StudentPayments /></div></>} />
          <Route path="/dashboard" element={<><Header /><div className="page-content"><ProtectedRoute><Dashboard /></ProtectedRoute></div></>} />
          <Route path="/students" element={<><Header /><div className="page-content"><ProtectedRoute><Students /></ProtectedRoute></div></>} />
          <Route path="/staffs" element={<><Header /><div className="page-content"><ProtectedRoute><Staffs /></ProtectedRoute></div></>} />
          <Route path="/attendance" element={<><Header /><div className="page-content"><ProtectedRoute><Attendance /></ProtectedRoute></div></>} />
          <Route path="/classes" element={<><Header /><div className="page-content"><ProtectedRoute><Classes /></ProtectedRoute></div></>} />
          <Route path="/exams" element={<><Header /><div className="page-content"><ProtectedRoute><Exams /></ProtectedRoute></div></>} />
          <Route path="/results" element={<><Header /><div className="page-content"><ProtectedRoute><Results /></ProtectedRoute></div></>} />
          <Route path="/settings" element={<><Header /><div className="page-content"><ProtectedRoute><Settings /></ProtectedRoute></div></>} />
          <Route path="/announcement/bulk-notice" element={<><Header /><div className="page-content"><ProtectedRoute><BulkNotice /></ProtectedRoute></div></>} />
          <Route path="/announcement/chats" element={<><Header /><div className="page-content"><ProtectedRoute><Chats /></ProtectedRoute></div></>} />
          <Route path="/announcement/insights" element={<><Header /><div className="page-content"><ProtectedRoute><TemplateInsights /></ProtectedRoute></div></>} />
          <Route path="/announcement/notification-tester" element={<><Header /><div className="page-content"><ProtectedRoute><NotificationTester /></ProtectedRoute></div></>} />
          <Route path="/announcement/gallery" element={<><Header /><div className="page-content"><ProtectedRoute><Gallery /></ProtectedRoute></div></>} />
          <Route path="/academic/fees" element={<><Header /><div className="page-content"><ProtectedRoute><Fees /></ProtectedRoute></div></>} />
          <Route path="/academic/transactions" element={<><Header /><div className="page-content"><ProtectedRoute><Transactions /></ProtectedRoute></div></>} />
          <Route path="/vehicles/track" element={<><Header /><div className="page-content"><ProtectedRoute><TrackVehicles /></ProtectedRoute></div></>} />
          <Route path="/utility/student-promotion" element={<><Header /><div className="page-content"><ProtectedRoute><StudentPromotion /></ProtectedRoute></div></>} />
          <Route path="/utility/system-properties" element={<><Header /><div className="page-content"><ProtectedRoute><SystemProperties /></ProtectedRoute></div></>} />
          <Route path="/utility/reconciliation" element={<><Header /><div className="page-content"><ProtectedRoute><Reconciliation /></ProtectedRoute></div></>} />
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/home" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
